export default __webpack_public_path__ + "static/media/MolecularWeightMarks.cb81cb05.gif";